<template>
  <router-link :to="to" v-slot="{ href, navigate, isActive, isExactActive }">
    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-hover"
    >
      <!--      :class="[isActive && 'menu-active', isExactActive && 'menu-active']"-->
      <a
        v-ripple
        :href="href"
        class="menu-link menu-link-sub-menu pl-14"
        @click="navigate"
      >
        <i v-if="submenu" class="menu-bullet menu-bullet-dot">
          <span></span>
        </i>
        <i v-else-if="icon" :class="['menu-icon', icon]"></i>
        <span class="menu-text menu-text-sub-menu" style="color: #000000">
          {{ title }}
          <v-badge
            v-if="counter_key"
            icon="bell-outline"
            :content="counter[counter_key] > 99 ? '99+' : counter[counter_key]"
            :value="counter[counter_key] > 0"
            color="#f00"
            overlap
            offset-x="-6"
            offset-y="9"
          >
          </v-badge>
        </span>
      </a>
    </li>
  </router-link>
</template>

<style lang="scss">
.menu-active {
  border-left: 5px solid #F37035;
  background-color: #F3F6F9;
}
</style>

<script>
export default {
  mounted() {
    this.activeOnLoading();
    this.activeOnClick();
  },
  name: "nav-menu-item",
  props: {
    to: {
      type: String
    },
    title: {
      type: String
    },
    icon: {
      type: String,
      default: null
    },
    submenu: {
      type: Boolean,
      default: false
    },
    counter_key: {
      type: String,
      default: null
    },
    counter: {
      type: Object
    }
  },
  methods: {
    activeOnLoading() {
      const path = window.location.pathname;
      const pathArray = path.split("/");
      if (pathArray.length > 3) {
        const action = pathArray[3].split("-");
        action.shift();
        const mainMenu = action.join("-");
        const defaultPath = pathArray[0]
          .concat("/")
          .concat(pathArray[1])
          .concat("/")
          .concat(pathArray[2])
          .concat("/")
          .concat(mainMenu);

        const currentMenu = document.querySelector(
          'ul li a[href="' + path + '"]'
        );
        const defaultMenu = document.querySelector(
          'ul li a[href="' + defaultPath + '"]'
        );

        currentMenu !== null
          ? currentMenu.parentElement.classList.add("menu-active")
          : defaultMenu.parentElement.classList.add("menu-active");
      }
    },

    activeOnClick() {
      const parent = document.querySelector("ul.menu-nav");
      const items = document.querySelectorAll("li.menu-item.menu-hover");
      parent.addEventListener("click", function(e) {
        if (!e.target.classList.contains("sub-menu-parent")) {
          items.forEach(el => {
            if (el.classList.contains("menu-active")) {
              el.classList.remove("menu-active");
            }
          });
        }

        if (e.target.classList.contains("menu-link-sub-menu")) {
          e.target.parentElement.classList.add("menu-active");
        }
        if (e.target.classList.contains("menu-text-sub-menu")) {
          e.target.parentElement.parentElement.classList.add("menu-active");
        }
      });
    }
  }
};
</script>
